<template>
  <v-layout row>
    <div class="text-xs-center pt-5" v-if="loadingCards">
      <v-progress-circular indeterminate color="blue"></v-progress-circular>
    </div>
    <v-flex xs12 sm12>
      <v-card>
        <v-list three-line>
          <v-subheader class="grey lighten-3 mb-3">Cartões</v-subheader>
          <template v-for="(item, index) in cards" class="pt-5 mt-5">
            <v-list-tile :key="index" avatar>
              <v-list-tile-avatar>
                <img
                  :src="
                    item.data && item.data.brand
                      ? item.data.brand
                      : '' | iconBrand
                  "
                />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <small>**** **** ****</small>
                  {{
                    item.data && item.data.last_digits
                      ? item.data.last_digits
                      : ""
                  }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  >Venc.
                  {{
                    item.data.expiration_date | expirationDate
                  }}</v-list-tile-sub-title
                >
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon
                  color="yellow darken-2"
                  v-if="userCS.card_default === item.data.id"
                  >star</v-icon
                >
                <v-icon
                  color="grey lighten-1"
                  v-else
                  @click="
                    changeTarget = item.data;
                    dialog = true;
                  "
                  ripple
                  >star_border</v-icon
                >
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="index < cards.length"
              :key="item.data.id"
            ></v-divider>
          </template>
          <div
            class="pl-3 pt-2 body-1"
            style="height: 100vh"
            v-if="cards.length <= 0"
          >
            Não há cartões cadastrados
          </div>
        </v-list>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline"
            >Tem certeza que deseja trocar o cartão padrão deste membro?</span
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Atual cartão padrão"
            prepend-icon="star_border"
            :value="
              '**** **** **** ' +
              (cards.length > 0
                ? cards.find((c) => c.data.id === userCS.card_default)
                : '0')
            "
            disabled
          ></v-text-field>
          <v-text-field
            label="Novo cartão padrão"
            prepend-icon="star"
            :value="'**** **** **** ' + changeTarget.last_digits"
            disabled
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            flat
            @click.prevent="changeDefaultCard()"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
// import { getCards } from "../../../services/support/cards"
import { updateDefaultCard } from "../../../services/support/cards";

export default {
  // props: ["userCS"],
  computed: {
    ...mapState("cs", ["userCS", "activeCards", "loadingCards"]),
    ...mapGetters("cs", ["cards"]),
    // ...mapGetters("cs", ["cards"])
  },
  // created() {
  //   if (this.userCS.cards) {
  //     getCards(this.userCS.cards)
  //       .then((cards) => {
  //         this.cards = cards
  //       })
  //       .catch((err) => {
  //         console.error(err)
  //       })
  //   }
  // },
  watch: {
    async activeCards() {
      if (
        this.activeCards === 1 &&
        this.cards.length <= 0 &&
        this.userCS.cards &&
        this.userCS.cards.length > 0 &&
        !this.cards
      ) {
        await this.getCardsByUser(this.userCS.cards);
        this.loading = false;
      }
    },
  },
  async mounted() {
    // console.log('mounted activeBilling: ', this.activeBilling)
    // console.log('mounted billing: ', this.billings.length)
    if (this.activeCards && this.activeCards === 1 && this.cards.length <= 0) {
      // console.log('mounted activeBilling 2: ', this.activeBilling)
      // console.log('mounted billing 2: ', this.billings.length)

      await this.getCardsByUser(this.userCS.cards);
      this.loading = false;
    }
  },
  data() {
    return {
      loadingChange: false,
      dialog: false,
      changeTarget: "",
      // cards: [],
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
    };
  },
  methods: {
    ...mapActions("cs", ["getCardsByUser"]),
    changeDefaultCard() {
      this.loadingChange = true;
      // console.log("card id", this.changeTarget.id)
      updateDefaultCard(this.userCS.id, this.changeTarget.id)
        .then(() => {
          this.dialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Cartão padrão alterado com sucesso!",
            "top",
            "green",
          );
          // alert('Sucesso!')
        })
        .catch((err) => {
          this.dialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar cartão padrão. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
  },
  filters: {
    iconBrand(value) {
      if (!value) return "";
      if (value === "visa") return "../../../icons/cards/visa.svg";
      if (value === "mastercard") return "../../../icons/cards/mastercard.svg";
      else return "";
    },
    expirationDate(value) {
      if (!value) return "";
      let mes = value.substring(0, 2);
      let ano = value.substring(2, 4);
      return mes + "/" + ano;
    },
  },
};
</script>
